// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"496":"83edc8afc0370428","524":"6406744b625b238b","640":"2a1316fa6141b928","952":"e91ac2fbf1f9e7d8"}[chunkId] + ".js";
};